import { RoadStructuresEarthworksAttributeConvert } from "@/attribute/convert/RoadStructuresEarthworksAttributeConvert";
import { FeatureType } from "../define/FeatureType";
import { AbstractRoadStructuresLayerFactory } from "./AbstractRoadStructuresLayerFactory";
import { IAttributeConvert } from "@/attribute/convert/IAttributeConvert";

/**
 * 点検データ(特定道路⼟⼯構造物)レイヤ 出力クラス
 */
export class RoadStructuresEarthworksLayerFactory extends AbstractRoadStructuresLayerFactory {
  /**
   * API取得用URL
   */

  URL_API = process.env.VUE_APP_ROAD_STRUCTURES_DB_API_URL + "/earthworks";

  /**
   * アイコンURL
   */

  URL_LAYER_ICON = "./icon/layer/structures-earthworks.png";

  /**
   * アイコンのサイズ
   */

  ICON_SIZE = 1;

  /**
   * 最大ズームレベル
   */

  LAYER_MAX_ZOOMLEVEL = 18;

  /**
   * 最小ズームレベル
   */

  LAYER_MIN_ZOOMLEVEL = 11;

  /**
   * コンテキストメニュー名称
   */
  CONTEXT_MENU_NAME = "点検DB_特定道路土工構造物";

  /**
   * 対象データ出力レイヤ
   */
  FEATURE_TYPE = FeatureType.Earthworks;

  /**
   * 対象Attribute変換クラス
   */
  ATTRIBUTE_CONVERT = (geoJSON: any) =>
    new RoadStructuresEarthworksAttributeConvert(geoJSON) as IAttributeConvert;
}
